import React, { createContext, useContext, useEffect, useState } from 'react';
import { STEP_UPLOAD_PIC_EDIT, STEP_UPLOAD_PIC_LIST, STEP_UPLOAD_PIC_SELECTED } from './helpers';
import EditImageViaCropperModal from './modals/EditImageViaCropperModal';
import { useSessionStorageInitialStrategy } from './hooks/useSessionStorageInitialStrategy';

const UploadImageWizardContext = createContext(undefined);

export const useUploadImageWizardContext = () => {
    const context = useContext(UploadImageWizardContext);

    if (!context) {
        throw new Error(
            'useUploadImageWizardContext must be used within UploadImageWizardContext.'
        );
    }

    return context;
};

export const UploadImageWizard = ({
    onImageUpload,
    uploadInProgress,
    imageName,
    renderPlaceholder,
    children,
}) => {
    const [uploadState, setUploadState] = useState(null);
    const [strategy, setStrategy] = useState(null);
    const [zoom, setZoom] = useState(0.5);
    const [src, setSrc] = useState(null); /** non-cropped */

    const interruptEditing = () => {
        setUploadState(null);
        setStrategy(null);
    };

    const goToList = () => {
        setStrategy(null);
        setUploadState(STEP_UPLOAD_PIC_LIST);
    };

    const isEditState = uploadState === STEP_UPLOAD_PIC_EDIT;

    useEffect(() => {
        if (strategy) setUploadState(STEP_UPLOAD_PIC_SELECTED);
    }, [strategy]);

    /** set initial value from pre-saved strategy in session storage */
    useSessionStorageInitialStrategy({ setStrategy });

    const contextState = {
        src,
        zoom,
        strategy,
        uploadState,
        imageName,
        setSrc,
        setZoom,
        setStrategy,
        setUploadState,
    };

    return (
        <UploadImageWizardContext.Provider value={contextState}>
            {renderPlaceholder(contextState)}
            {children}
            {isEditState && (
                <EditImageViaCropperModal
                    src={src}
                    zoom={zoom}
                    setZoom={setZoom}
                    onClose={interruptEditing}
                    goToList={goToList}
                    onImageUpload={onImageUpload}
                    uploadInProgress={uploadInProgress}
                />
            )}
        </UploadImageWizardContext.Provider>
    );
};
